module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "regist"
  }, [_c('el-dialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.zcFormVisible,
      "custom-class": "dialog-t zc",
      "width": "677px",
      "before-close": _vm.clearZc
    },
    on: {
      "update:visible": function($event) {
        _vm.zcFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input_text"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('sup', [_vm._v("*")]), _vm._v("账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zc_form.username),
      expression: "zc_form.username"
    }],
    staticClass: "text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zc_form.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.zc_form, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('sup', [_vm._v("*")]), _vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zc_form.password),
      expression: "zc_form.password"
    }],
    staticClass: "text",
    attrs: {
      "type": "password",
      "minlength": "6",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.zc_form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.zc_form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('sup', [_vm._v("*")]), _vm._v("确认密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zc_form.confirm_password),
      expression: "zc_form.confirm_password"
    }],
    staticClass: "text",
    attrs: {
      "type": "password",
      "minlength": "6",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.zc_form.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.zc_form, "confirm_password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('sup', [_vm._v("*")]), _vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zc_form.captcha),
      expression: "zc_form.captcha"
    }],
    ref: "captcha_input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zc_form.captcha)
    },
    on: {
      "focus": _vm.showCaptchaEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.zc_form, "captcha", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCaptcha),
      expression: "showCaptcha"
    }],
    ref: "captcha_img",
    attrs: {
      "width": "105",
      "height": "32"
    },
    on: {
      "click": function($event) {
        _vm.changeImg($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "zc_p"
  }, [_c('input', {
    ref: "checkbox",
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v("我已届满合法博彩年龄，且同意各项开户条约。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.regist
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e24172"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/regist/regist.vue
// module id = 614
// module chunks = 31